import { Plus } from 'lucide-react';
import { Button } from '@frontend/shadcn/components/ui/button';
import React from 'react';
import { FlowNodeData } from '../../types';

const AddNodeButton = ({ data, nodeId }: { data: FlowNodeData, nodeId: string }) => {
  // Get the isSelected state from the parent node data
  const isNodeSelected = data.isSelected;

  return (
    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 z-10">
      {/* Button container with semicircular arc */}
      <div className="relative flex items-center justify-center">
        {/* Background mask to hide connecting line behind button */}
        <div className="absolute w-8 h-8 bg-white rounded-full z-0" />

        {/* Semicircular arc border - top half */}
        <svg
          width="40"
          height="40"
          viewBox="0 0 36 36"
          className="absolute -top-0.5 z-10"
        >
          <path
            d="M 18 3 A 15 15 0 0 1 33 18"
            stroke={isNodeSelected ? '#000000' : '#e5e7eb'}
            strokeWidth={1}
            fill="none"
          />
          <path
            d="M 3 18 A 15 15 0 0 1 18 3"
            stroke={isNodeSelected ? '#000000' : '#e5e7eb'}
            strokeWidth={1}
            fill="none"
          />
        </svg>

        {/* Plus button */}
        <Button
          size="sm"
          className="relative flex w-6 h-6 items-center justify-center p-0 bg-gray-600 rounded-full hover:bg-gray-700 shadow-md ring-0 m-[6px] z-20"
          data-plus-button
          onClick={(e) => {
            e.stopPropagation();
            data.onRequestToolbarOpen?.(nodeId);
            data.onShowDashedPlaceholder?.(nodeId);
          }}
        >
          <Plus className="w-3 h-3 text-white" strokeWidth={2.5} />
        </Button>
      </div>
    </div>
  );
};

export default AddNodeButton;
